import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import appVersion from '../appVersion.json';

const UserFooter = () => (
  <Box as="footer" w="full" py={4} color="whiteAlpha.700" fontSize="sm" mt="auto">
    <VStack spacing={1} align="center">
      <Text textAlign="center">
        &copy; Copyright {new Date().getFullYear()} Mobile Global eSports.<br />All rights reserved.
      </Text>
      <Text textAlign="center">
        Version: {appVersion.pre_version} {appVersion.version}
      </Text>
    </VStack>
  </Box>
);

export default UserFooter; 